/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Searchreadysubtitle2Inputs */

const en_searchreadysubtitle2 = /** @type {(inputs: Searchreadysubtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The more complete your place, the more often Google, ChatGPT and others show it.`)
};

const de_searchreadysubtitle2 = /** @type {(inputs: Searchreadysubtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je vollständiger dein Ort, desto öfter zeigen Google, ChatGPT und Co. ihn an.`)
};

/**
* | output |
* | --- |
* | "The more complete your place, the more often Google, ChatGPT and others show it." |
*
* @param {Searchreadysubtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const searchreadysubtitle2 = /** @type {((inputs?: Searchreadysubtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Searchreadysubtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_searchreadysubtitle2(inputs)
	return de_searchreadysubtitle2(inputs)
});
export { searchreadysubtitle2 as "searchReadySubtitle" }